export const ItemTypes = {
  DAY: "DAY",
  DOW: "DOW",
  WEEK: "WEEK",
};
